import type { AcquirerDto } from "src/app/features/Acquirer/types/AcquirerDto";
import type { AcquirerContractEntity } from "src/app/features/Acquirer/types/subTypes/AcquirerContractEntity";
import type { AcquirerEntity } from "../../types/AcquirerEntity";
import { AcquirerToVirtualDtoToEntity } from "./AcquirerToVirtualDtoToEntity";

export const AcquirerPhysicalDtoToEntity = ({
    contracts,
    hostDeviceIdMaskEdit,
    hostDeviceIdMaskGenerate,
    acquirersToVirtual,
    ...rest
}: Readonly<AcquirerDto>): AcquirerEntity => {
    const newContracts: AcquirerContractEntity[] =
        contracts?.map((contract) => ({
            id: contract.id,
            contractNumber: contract.contractNumber,
            siteName: contract.siteName,
            validFrom: contract.validFrom,
            validTo: contract.validTo,
            changed: contract.changed,
            physical: contract.physical,
        })) ?? [];

    const restoredHostDeviceIdMaskEdit = hostDeviceIdMaskEdit ?? "";
    const restoredHostDeviceIdMaskGenerate = hostDeviceIdMaskGenerate ?? "";

    const acquirersToVirtualEntity = acquirersToVirtual?.map(AcquirerToVirtualDtoToEntity) ?? [];

    return {
        ...rest,
        hostDeviceIdMaskEdit: restoredHostDeviceIdMaskEdit,
        hostDeviceIdMaskGenerate: restoredHostDeviceIdMaskGenerate,
        contracts: newContracts,
        acquirersToVirtual: acquirersToVirtualEntity,
    };
};
